export default function useSilentUri(unsubscribeSilentUriLength: number): boolean {
    return unsubscribeSilentUriLength > 0;
}
